import { animate, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-secured-tooltip',
  templateUrl: './secured-tooltip.component.html',
  styleUrls: ['./secured-tooltip.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate(
          '250ms cubic-bezier(0.25, 1.25, 0.5, 1)',
          style({ opacity: 1, transform: 'scale(1)' })
        ),
      ]),
      transition(':leave', [
        animate(
          '50ms cubic-bezier(0.6, 0.04, 0.98, 0.2)',
          style({ opacity: 0, transform: 'scale(0.9)' })
        ),
      ]),
    ]),
  ],
})
export class SecuredTooltipComponent {
  @HostBinding('@fadeInOut') fadeInOut = true;
}